<template>
    <div class="view-login has-centered-content">
        <div class="box">
            <div class="field">
                <label class="label">Email</label>
                <div class="control">
                    <input class="input" type="email" name="email" placeholder="Email" v-model="email">
                </div>
            </div>
            <div class="field">
                <label class="label">Password</label>
                <div class="control">
                    <input class="input" type="password" name="password" placeholder="••••••••" v-model="password">
                </div>
            </div>
            <div class="control">
                <button class="button is-primary" @click="signIn" :class="{'is-loading': working}">Login</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {signIn} from "../firebase";
    import {PUSH_MESSAGE} from "../store";

    export default {
        name: "login",
        data() {
            return {
                email: "",
                password: "",
                working: false
            }
        },
        methods: {
            signIn() {
                this.working = true;
                signIn(this.email, this.password)
                    .then(() => {
                        this.email = "";
                        this.password = "";
                        this.working = false;
                    })
                    .catch(err => {
                        this.working = false;
                        // noinspection JSIgnoredPromiseFromCall
                        this.$store.dispatch(PUSH_MESSAGE, {
                            title: "Error",
                            message: err.message,
                            type: "danger"
                        });
                    });
            }
        },
        mounted() {
            document.title = "CMS - Login";
        }
    }
</script>

<style lang="scss">
    @import "~bulma/sass/utilities/initial-variables";
    @import "~bulma/sass/utilities/derived-variables";
    @import "~bulma/sass/utilities/mixins";

    .view-login .box {
        width: 300px;
    }

    @include mobile {
        .view-login .box {
            width: 100%;
            margin: $gap / 4;
        }
    }
</style>